import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  iconButtonRoot: {
    outline: 'none',
    color: ({ color, theme: subTheme }) =>
      color || (subTheme === 'embed' ? theme.grey3 : theme.white1)
  }
}));
